import { useDataValueOnce } from 'Logic/FlowShortcuts'
import { useDataValue } from 'Simple/Data.js'

export default function useGetDefaultTab(props, data) {
  let board_id = useDataValueOnce({
    context: 'flow_shortcuts',
    path: 'boardId',
    viewPath: props.viewPath,
  })
  let task_id = useDataValueOnce({
    context: 'flow_shortcuts',
    path: 'taskId',
    viewPath: props.viewPath,
  })

  let is_new_tasks_enabled = useDataValue({
    context: 'global',
    path: 'feature_flags.is_new_tasks_enabled',
    viewPath: props.viewPath,
  })

  return function ensureDefaultTab(maybeTab, id) {
    if (
      (maybeTab && !is_new_tasks_enabled) ||
      maybeTab?.selected?.filters?.submenu_tab_id ||
      maybeTab?.selected?.board_id ||
      maybeTab?.selected?.task_overlay?.task_id
    )
      return maybeTab

    return {
      ...data,
      visible: is_new_tasks_enabled,
      selected: {
        ...data.selected,
        board_id: board_id,
        task_overlay: {
          ...data.selected.task_overlay,
          task_id: task_id,
          open: Boolean(task_id),
        },
      },
      viewPath: props.viewPath,
    }
  }
}
